module.exports = __webpack_public_path__ + "static/media/stop-13.cc0cdc2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-13.svg
// module id = 1358
// module chunks = 0